import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Utensils, Coffee, Music, Sun, Ship, Landmark, TreePine, Clock, Ticket, Cpu } from 'lucide-react';
const scheduleData = [{
  day: 'Friday, June 26',
  title: 'Arrival & Welcome',
  events: [{
    time: '11:00 AM – 2:00 PM',
    name: 'Arrival, Check-in & Family Field Day Kick Off',
    detail: 'Presidio: Western Lawn\nParking/Uber drop-off: Anza Ave or French Court (French Court is closer to Western Lawn)',
    icon: Sun,
    mandatory: true,
    link: 'https://maps.app.goo.gl/Tu1vs9aovgNkjQnW8'
  }, {
    time: 'Afternoon',
    name: 'Explore SF',
    detail: 'Pier 39, SFMOMA, Chinatown',
    icon: Landmark,
    mandatory: false
  }, {
    time: '3:00 – 5:00 PM',
    name: 'Zipline (Company) Tour',
    detail: '333 Coprey Way, South San Francisco, CA 94080\nFor anyone interested in drones or robotics: tour the headquarters of Zipline, a drone delivery company rolling out instant deliveries in the US now.',
    icon: Cpu,
    mandatory: false,
    link: 'https://maps.google.com/?q=333+Coprey+Way,+South+San+Francisco,+CA+94080'
  }, {
    time: '5:30 - 8:30 PM',
    name: 'Banquet Dinner',
    detail: 'Epic Steak - Bay Room & Terrace',
    icon: Utensils,
    mandatory: true
  }]
}, {
  day: 'Saturday, June 27',
  title: 'Adventure & Feast',
  events: [{
    time: 'Morning',
    name: 'Optional: Ferry Building Farmers Market',
    detail: 'Browse local vendors and grab breakfast',
    icon: Coffee,
    mandatory: false
  }, {
    time: 'Daytime',
    name: 'Choose Your Adventure',
    detail: "Option A: Boat ride to Angel Island + lunch — boarding at 10:00 AM (hosted by Kingsley's family)\nOption B: De Young Museum + Golden Gate Park + Cal Academy (self-guided)",
    icon: Ship,
    mandatory: false,
    link: 'https://www.sfport.com/maritime/harbors-berthings/south-beach-harbor/sbh-transit-and-parking-information'
  }, {
    time: '5:30 PM',
    name: 'Banquet Dinner',
    detail: 'Harborview — Chinese cuisine',
    icon: Utensils,
    mandatory: true
  }]
}, {
  day: 'Sunday, June 28',
  title: 'Brunch & Farewell',
  events: [{
    time: '10:00 AM',
    name: 'Dim Sum Brunch',
    detail: 'Yank Sing - Spear Street',
    icon: Coffee,
    mandatory: false,
    link: 'https://yanksing.com/'
  }, {
    time: '1:05 PM',
    name: 'Giants Game',
    detail: "Oracle Park — catch a game before you go! (hosted by Kingsley's family)",
    icon: Ticket,
    mandatory: false
  }]
}];
export function Schedule() {
  return <section className="py-24 px-6 bg-paper-alt relative border-y border-ink/5" data-id="element-86">
      <div className="max-w-4xl mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-88">
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-89">
            Weekend Itinerary
          </h2>
          <p className="text-ink-light text-lg" data-id="element-90">
            A mix of must-dos and choose-your-own-adventure.
          </p>
        </motion.div>

        <div className="space-y-16" data-id="element-91">
          {scheduleData.map((day, dayIndex) => <motion.div key={day.day} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: dayIndex * 0.2
        }} className="relative" data-id="element-92">
              <div className="flex flex-col md:flex-row gap-8" data-id="element-93">
                {/* Day Header */}
                <div className="md:w-1/3 md:text-right" data-id="element-94">
                  <h3 className="text-2xl text-terracotta mb-1" data-id="element-95">{day.day}</h3>
                  <p className="text-sage italic" data-id="element-96">{day.title}</p>
                </div>

                {/* Timeline Line (Desktop) */}
                <div className="hidden md:flex flex-col items-center relative" data-id="element-97">
                  <div className="w-3 h-3 rounded-full bg-amber z-10" data-id="element-98" />
                  <div className="w-px h-full bg-ink/10 absolute top-3" data-id="element-99" />
                </div>

                {/* Events */}
                <div className="md:w-2/3 space-y-6 pb-8" data-id="element-100">
                  {day.events.map((event, eventIndex) => {
                const Icon = event.icon;
                return <div key={eventIndex} className="flex items-start gap-4 bg-paper p-4 rounded-sm shadow-sm border border-ink/5" data-id="element-101">
                        <div className="p-2 bg-sage/10 rounded-full text-sage shrink-0" data-id="element-102">
                          <Icon className="w-5 h-5" data-id="element-103" />
                        </div>
                        <div className="flex-1" data-id="element-104">
                          <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-105">
                            <span className="text-sm text-amber font-medium" data-id="element-106">
                              {event.time}
                            </span>
                            {event.mandatory ? <span className="text-[10px] uppercase tracking-wider bg-terracotta/10 text-terracotta px-2 py-0.5 rounded-sm font-semibold" data-id="element-107">
                                Group
                              </span> : <span className="text-[10px] uppercase tracking-wider bg-sage/10 text-sage px-2 py-0.5 rounded-sm font-semibold" data-id="element-108">
                                Optional
                              </span>}
                          </div>
                          <div className="text-ink text-lg" data-id="element-109">{event.name}</div>
                          {event.detail && <p className="text-ink-light text-sm mt-1 whitespace-pre-line" data-id="element-110">
                              {event.detail}
                            </p>}
                          {event.link && <a href={event.link} target="_blank" rel="noopener noreferrer" className="inline-block text-sm text-terracotta hover:underline mt-1" data-id="element-111">
                              Map →
                            </a>}
                        </div>
                      </div>;
              })}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}